/** es 国家/地区落地页 */
export default {
  "label": "Spain",
  "path": "/locations/free-spain-vpn/",
  "hreflang": "es",
  "htmlLang": "es",
  "title": "Secure VPN – VPN gratis con IP española",
  "description": "Protege tu conexión con Secure VPN y descubre cómo obtener una dirección IP española. Consulta los servidores disponibles y los pasos para configurar la conexión VPN.",
  "h1": "VPN gratis con una dirección IP española",
  "heroLead": "Descarga Secure VPN y disfruta de una conexión cifrada rápida para navegar, ver contenido, jugar y proteger tu privacidad online.",
  "heroPoints": [
    "1 dispositivo protegido",
    "Sin registros ni anuncios",
    "Ilimitado y gratis",
    "Servidores VPN globales"
  ],
  "heroCtaLabel": "Descargar APK",
  "privacyTitle": "Protege tu privacidad con un VPN gratis",
  "privacyLead": "Secure VPN es una aplicación sencilla que ayuda a mantener tu privacidad en internet. Con un toque puedes conectarte a un servidor seguro, ocultar tu dirección IP y navegar con más seguridad en Wi-Fi público, redes móviles o internet doméstico. Es ideal para quienes buscan protección rápida sin configuraciones complicadas.",
  "privacySubtitle": "Beneficios clave",
  "privacyBenefits": [
    {
      "title": "100% gratis y sin límites",
      "desc": "Disfruta de acceso VPN ilimitado sin límites diarios ni cargos ocultos."
    },
    {
      "title": "Protección en Wi-Fi público",
      "desc": "Mantente más seguro en cafeterías, aeropuertos, hoteles y otras redes compartidas."
    },
    {
      "title": "Política sin registros",
      "desc": "Tu actividad es tuya. No guardamos registros de las webs que visitas mientras usas la VPN."
    }
  ],
  "featuresTitle": "Qué puedes hacer con el VPN gratis de Secure",
  "featureCards": [
    {
      "title": "Seguridad online cifrada",
      "desc": "Protege tus datos personales y el tráfico de internet con un cifrado fuerte."
    },
    {
      "title": "Servidores globales rápidos",
      "desc": "Conéctate a servidores VPN de alta velocidad para navegar, ver vídeos y usar internet a diario."
    },
    {
      "title": "Múltiples ubicaciones",
      "desc": "Elige servidores en distintos países y mantén una conexión estable donde estés."
    },
    {
      "title": "Conexión con un toque",
      "desc": "Conéctate al mejor servidor disponible al instante, sin configuración complicada."
    },
    {
      "title": "Servidores en todo el mundo",
      "desc": "Accede a servidores globales rápidos y fiables siempre que los necesites."
    },
    {
      "title": "Streaming fluido",
      "desc": "Disfruta de vídeos, directos y entretenimiento online con una conexión estable."
    },
    {
      "title": "Alto rendimiento",
      "desc": "Los servidores optimizados ofrecen conexión rápida y estable para navegar y jugar."
    },
    {
      "title": "100% gratis y sin límites",
      "desc": "Disfruta de acceso VPN ilimitado sin límites diarios ni cargos ocultos."
    }
  ],
  "extraTitle": "Más motivos para usar Secure VPN",
  "extraItems": [
    "Ligero y fácil de usar",
    "Protección en Wi-Fi público",
    "Oculta tu dirección IP",
    "Navega sin límites",
    "Servidores rápidos y estables"
  ],
  "extraCta": "Descargar APK",
  "extraPlayPrefix": "Download from",
  "dailyTitle": "Secure VPN en tu día a día online",
  "dailyScenes": [
    {
      "title": "Juega sin límites de red",
      "tags": [
        "PUBG Mobile",
        "Call of Duty: Mobile",
        "Free Fire",
        "Mobile Legends"
      ]
    },
    {
      "title": "Videollamadas y mensajes privados",
      "tags": [
        "WhatsApp",
        "Telegram",
        "Skype",
        "Viber"
      ]
    },
    {
      "title": "Conéctate seguro en Wi-Fi público",
      "tags": [
        "Wi-Fi público",
        "Trabajos",
        "Colegios",
        "Aeropuertos"
      ]
    },
    {
      "title": "Protege tu privacidad online",
      "tags": [
        "Cifrado fuerte",
        "Ocultar dirección IP",
        "Política sin registros",
        "Privacidad frente al ISP"
      ]
    }
  ],
  "installTitle": "Cómo descargar e instalar Secure VPN",
  "installLead": "Sigue estos sencillos pasos:",
  "installSteps": [
    {
      "title": "Abre la página de descarga",
      "desc": "Ve a la página de descarga de Secure VPN o a una tienda de aplicaciones fiable para obtener la última versión."
    },
    {
      "title": "Descarga Secure VPN",
      "desc": "Pulsa Descargar y espera a que termine la descarga del APK o del archivo de la app."
    },
    {
      "title": "Activa el permiso de instalación",
      "desc": "Si usas un APK, permite Instalar apps desconocidas en tu navegador o gestor de archivos."
    },
    {
      "title": "Instala la aplicación",
      "desc": "Abre el archivo descargado, pulsa Instalar y espera a que termine el proceso."
    },
    {
      "title": "Abre y conéctate",
      "desc": "Inicia Secure VPN, elige un servidor y pulsa Conectar para iniciar una conexión segura."
    },
    {
      "title": "Disfruta de una navegación segura",
      "desc": "Tu tráfico ya está protegido. Navega, ve vídeos, juega y usa Wi-Fi público con más seguridad."
    }
  ],
  "installCta": "Descargar APK",
  "compareTitle": "App Secure VPN o proxy web gratis",
  "compareLead": "Una app VPN y un proxy web gratis ofrecen más privacidad, pero funcionan de forma distinta. La VPN protege todo el dispositivo con conexión cifrada, mientras que el proxy se centra en el navegador.",
  "compareNote": "Para el uso habitual de internet, la app Secure VPN ofrece una solución más completa y fiable.",
  "compareHeaders": [
    "Característica",
    "App Secure VPN",
    "Proxy web gratis"
  ],
  "compareRows": [
    {
      "feature": "Instalación",
      "vpn": "Instalación sencilla",
      "proxy": "No requiere instalación"
    },
    {
      "feature": "Uso",
      "vpn": "Protege todas las apps y webs",
      "proxy": "Solo funciona en el navegador"
    },
    {
      "feature": "Privacidad",
      "vpn": "Cifrado fuerte y conexión segura",
      "proxy": "Privacidad básica de navegación"
    },
    {
      "feature": "Velocidad",
      "vpn": "Servidores VPN optimizados",
      "proxy": "Depende del servidor proxy"
    },
    {
      "feature": "Protección del dispositivo",
      "vpn": "Protección completa",
      "proxy": "Solo a nivel del navegador"
    }
  ],
  "privacyChoiceTitle": "¿Cuál elegir?",
  "privacyChoiceP1": "si quieres más privacidad, conexión rápida y protección para todo el dispositivo.si quieres más privacidad, conexión rápida y protección para todo el dispositivo.",
  "privacyChoiceP2": "si solo necesitas acceso temporal desde el navegador para tareas sencillas.",
  "privacyChoiceP3": "Para el uso habitual de internet, la app Secure VPN ofrece una solución más completa y fiable.",
  "reviewsTitle": "Con la confianza de los usuarios",
  "reviewsLead": "Usuarios de todo el mundo confían en Secure VPN por sus conexiones rápidas, estables y seguras. Los servidores fiables y la protección de la privacidad ayudan a navegar, ver contenido, jugar y mantenerse conectado cada día.",
  "reviews": [
    {
      "name": "James",
      "text": "La conexión es rápida y fácil de usar. Puedo navegar seguro esté donde esté."
    },
    {
      "name": "Emily",
      "text": "Secure VPN funciona bien y mantiene mi conexión estable en Wi-Fi público."
    },
    {
      "name": "Daniel",
      "text": "Buena velocidad y servidores fiables para streaming, juegos y uso diario."
    }
  ],
  "faqTitle": "Preguntas frecuentes",
  "faqs": [
    {
      "q": "¿Una VPN ralentiza internet?",
      "a": "La velocidad puede reducirse ligeramente porque el tráfico pasa por un servidor seguro. Normalmente la diferencia es pequeña y puedes navegar y ver contenido sin problemas."
    },
    {
      "q": "¿SecureVPN es segura?",
      "a": "SecureVPN cifra la conexión y oculta tu dirección IP. Descarga siempre desde fuentes fiables y revisa la política de privacidad."
    },
    {
      "q": "¿Es legal usar una VPN?",
      "a": "En la mayoría de países, usar una VPN es legal y habitual por privacidad y seguridad. Cumple las leyes y normas de tu zona."
    },
    {
      "q": "¿Cuánto tiempo puedo estar conectado?",
      "a": "Puedes mantener SecureVPN conectado mientras necesites una conexión protegida. Los límites pueden variar según la versión y las condiciones del servicio."
    },
    {
      "q": "¿Cómo se usa Secure VPN?",
      "a": "Instala Secure VPN, abre la app, elige un servidor y pulsa conectar. Una vez conectado, el tráfico pasa por la VPN."
    },
    {
      "q": "¿La VPN afecta a la batería?",
      "a": "Puede consumir algo más de batería porque mantiene la conexión activa, pero el impacto suele ser mínimo en el uso diario."
    }
  ]
};
